import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { updateMetaTags } from './utils/analytics';

// SEO optimization
updateMetaTags(
  'Orifel Technologies - Your Vision, Delivered',
  'Innovative IT and software development company creating world-class digital solutions. Featuring VeltraPay payment gateway and ILU digital wallet.',
  'fintech, payment gateway, digital wallet, software development, IT solutions, VeltraPay, ILU Wallet, Zambia, Africa'
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
